import React, { useMemo } from 'react';
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from '../../../../_metronic/_partials/controls';
import { injectIntl } from 'react-intl';
import SalesFilter from './sales-filter/SalesFilter';
import SalesTable from './sales-table/SalesTable';
import { useSalesUIContext } from './SalesUIContext';

const SalesCard = (props) => {
  const { intl } = props;
  const title = intl.formatMessage({ id: 'SALES.TITLE.LIST' });
  const salesUIContext = useSalesUIContext();
  const salesUIProps = useMemo(() => {
    return {
      queryParams: salesUIContext.queryParams,
      setQueryParams: salesUIContext.setQueryParams,
      openViewSaleDialog: salesUIContext.openViewSaleDialog,
      openCreateSaleDialog: salesUIContext.openCreateSaleDialog,
      openDeleteSalesDialog: salesUIContext.openDeleteSalesDialog,
    };
  }, [salesUIContext]);

  return (
    <Card id='salesCard'>
      <CardHeader title={title}>
        <CardHeaderToolbar>
          <button
            type='button'
            className='btn btn-primary'
            onClick={salesUIProps.openCreateSaleDialog}
          >
            Борлуулалт бүртгэх
          </button>
        </CardHeaderToolbar>
      </CardHeader>
      <CardBody>
        <SalesFilter props />
        <SalesTable props />
      </CardBody>
    </Card>
  );
};

export default injectIntl(SalesCard);
